import type {
  RuleBuilderAggregateType,
  RuleBuilderAttributeType,
  RuleBuilderConditionType,
  RuleEntityAttributeType,
  RuleEntityType,
} from './types';

const initializeAttribute = (
  attribute: RuleEntityAttributeType,
): Partial<RuleBuilderAttributeType> => {
  return {
    field: attribute.id,
    operator: 'eq',
    value: undefined,
    type: attribute.type,
    display: attribute.display,
  };
};

const initializeDefaultAggregate = (): RuleBuilderAggregateType => {
  return {
    type: 'number',
    function: 'count',
    operator: 'gte',
    value: [1],
  };
};

export const initializeCondition = (
  ruleEntity: RuleEntityType,
  attribute?: RuleEntityAttributeType,
): RuleBuilderConditionType => {
  // Get all default attributes
  const defaultAttributes = ruleEntity.attributes
    .filter((attr) => attr.isDefault)
    .map(initializeAttribute);

  // If an attribute is provided and it's not already in defaults, add it
  const providedAttribute =
    attribute && !attribute.isDefault ? [initializeAttribute(attribute)] : [];

  const initialAttributes = [...defaultAttributes, ...providedAttribute];
  const defaultAggregate =
    ruleEntity.cardinality === 'many' ? initializeDefaultAggregate() : undefined;

  return {
    object: ruleEntity.id,
    cardinality: ruleEntity.cardinality,
    attributes: initialAttributes,
    aggregate: defaultAggregate,
  };
};
